if (!window.reportError) {
    window.reportError = function reportError(error: unknown) {
        if (!(error instanceof Error)) {
            console.error(error);
            return;
        }
        window.dispatchEvent(
            new ErrorEvent('error', {
                message: error.message,
                error,
            })
        );
    };
}
